import { Injectable } from '@angular/core';
import { ApiService } from '@xref/ngx';
import {map} from 'rxjs/operators';
import { AuthService } from '../auth/auth.service';

export class VerifyEmailData {
  email: string;
  first_name: string;
  last_name: string;
}

@Injectable({
  providedIn: 'root'
})
export class VerifyService {
  submittedEmail = '';

  // Shareable state of email submit errors
  emailError = {
    generic: false,
    whitelist: false
  };

  constructor(
    private api: ApiService,
    private auth: AuthService
  ) {}

  verifyEmail(postData: VerifyEmailData) {
    return this.api.post('v1/otp/generate-challenge', postData).pipe(map((data) => data));
  }

  submitEmailVerifyCode(code: number) {
    const postData = {
      "email": this.submittedEmail,
      "otp_token": code
    };

    const dataMapper = (data: any) => {
      this.auth.setSessionToken(data.token);
      return data;
    };

    return this.api.post('v1/jwt/obtain/otp', postData).pipe(map(dataMapper));
  }
}
